function statesUpdate() {
  var activeCountry = $('#rf-country').find('option:selected').val();
  //stateCountryJson();
  var states = $('#rf-country').find('option:selected').attr('data-provinces');
  if(states != '[]') {
    // console.log("state array is not empty")
    $('#rf-state').show();
    states = JSON.parse(states);
    var stateLen = states.length;
    $('#rf-state').find('option').remove();
    $('#rf-state').append('<option disabled>State</option>');
    for(i=0; i < stateLen; i++) {
      $('#rf-state').append('<option>'+states[i][0]+'</option>');
    }
  }
  else {
    $('#rf-state').hide();
  }
}


if($('body').hasClass('page-repair-request')) {
//     statesUpdate();
}



// $('#rf-color').change(function() {
//   if($(this).find('option:selected').text() != 'Color*') {
//     $(this).removeClass('redBorder');
//   }
// });
$('#rf-state').change(function() {
  if(!$(this).find('option:selected').text().includes('State')) {
    // console.log("does not equal state ")
    $(this).removeClass('redBorder');
  }
});

 //Production URL: 
 var cgiEndpoint = "https://cgi.briggs-riley.com";

// Dev testing URL:
//var cgiEndpoint = "https://cgitest.briggs-riley.com";


// Click event when Repair Request form is submitted
$('#repairRequest').on('submit', function(e) {
  console.log("submit")
  e.preventDefault();
  if($('#rf_terms').is(':checked')) {
    e.preventDefault();
    $('.loaderWrap').show();
    var form_data = jQuery("#repairRequest").serialize();
    form_data += '&form_key=ljX7FDGqDy4dUBQh';
    console.log('form data is ', form_data)
    let RawCustomerEmail = $('#SIEMAIL').val() || '';
      let CustomerEmail = RawCustomerEmail.trim();
    let RawCustomerPhone = $('#SIPHON').val() || '';
      let CustomerPhone = RawCustomerPhone.trim();
      if (CustomerPhone.length === 10) {
        CustomerPhone = "+1" + CustomerPhone
      }
    let RawCustomerName = $('#SINAME').val();
      let TrimmedCustomerName = RawCustomerName.trim() ;
      let CustomerNameArr = TrimmedCustomerName.split(' ');
      let CustomerFirstName = CustomerNameArr[0] || '';
      let CustomerLastName = CustomerNameArr[CustomerNameArr.length - 1] || '';
    let RawAddy1 = $('#SIADR1').val()  ;
      let Addy1 = RawAddy1.trim() || '';
    let RawAddy2 = $('#SIADR2').val() ;
      let Addy2 = RawAddy2.trim()|| '';
    let RawCity = $('#SICITY').val()  ;
      let City = RawCity.trim() || '';
    let CustomerCountry = $('#rf-country').val()  || '';
    let CustomerState = $('#rf-state').val()  || '';
    let RawZip = $('#SIZIP').val()  ;
      let Zip = RawZip.trim()|| '';

    // If customer consents to email marketing, send 
    // Data to Klaviyo API
    if($('#rf_enotifs').is(':checked')) {
      let jsonData = 
      {
        data: {
          type: 'profile',
          attributes: {
            email: CustomerEmail,
            first_name: CustomerFirstName,
            last_name: CustomerLastName,
            location: {
              address1: Addy1,
              address2: Addy2,
              city: City,
              country: CustomerCountry,
              region: CustomerState,
              zip: Zip,
              timezone: 'America/New_York'
            }
          }
        }
      };
      let jsonDataString = JSON.stringify(jsonData)
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json', 
          revision: '2023-10-15', 
          'content-type': 'application/json'
        },
        body: jsonDataString
      };

      fetch('https://a.klaviyo.com/client/profiles/?company_id=X6BHeP', options)
      .then(response => console.log(response))
      .catch(err => console.error(err));
    };

    // If customer consents to marketing via text 
    // Send data to Attentive Mobile API via Zapier
    if($("#rf_marketing").is(':checked')){

      // Define the Zapier API endpoint URL
      const apiUrl = 'https://hooks.zapier.com/hooks/catch/17910484/3eo017l/';
     
      // Define the data to be sent in the request body
      const requestBody =  {
        "user": {
          "phone": `${CustomerPhone}`,
          "email": `${CustomerEmail}`
        },
        "signUpSourceId": "918706",
        "subscriptionType": "MARKETING",
        "singleOptIn": false
      }
console.log('request body: ', requestBody)
      // Define the request options, including method, headers, and body
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(requestBody),
      };
console.log('request options: ', requestOptions)
      // Make the POST request
      fetch(apiUrl, requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Failed to subscribe customer');
          }
        })
        .then((data) => {
          console.log('Customer subscribed successfully:', data);
        })
        .catch((error) => {
          console.error('Error subscribing customer', error);
        });
    }


    if($('#rf-state').find('option:selected').text().includes("State")) {
      $('#rf-state').addClass('redBorder');
      // console.log('adds redborder class', $('#rf-state').find('option:selected').text())
      $('.buttonInfoGrid').find('.repairErrorMsg').remove();
      $('.buttonInfoGrid').append('<p class="repairErrorMsg" id="repairErrorMsg">Please select a state*</p>');
      $('#rf-state').attr('aria-describedby', 'repairErrorMsg')
      $('#rf-state').focus()
      setTimeout(function() {
        $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
      },3000);
      $('.loaderWrap').hide();
    } else {
      // console.log("rf state has  value! ", $('#rf-state').find('option:selected').text())

      if($('#shipping_label').is(':checked')){
        $.ajax({
            data: form_data,
            url: cgiEndpoint + "/cgi/cgpbsrrh1",
            method: "POST",
            dataType: "json",
            success: function(response){
              console.log('was successful!')
              if(response.error) {
                console.log('response had error', response.error)
                $('.loaderWrap').hide();
                $('.buttonInfoGrid').find('.repairErrorMsg').remove();
                $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.error.error_message+'</p>');
                setTimeout(function() {
                  $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
                },3000);
              }
              else {
                $('.loaderWrap').hide();
                console.log("response had no error")
                $('.buttonInfoGrid').find('.repairMsg').remove();
                $('.buttonInfoGrid').append('<p class="repairMsg">Request Sent Successfully!</p>');
                setTimeout(function() {
                  $('.buttonInfoGrid').find('.repairMsg').fadeOut(300);
                },3000);
                var raNumber = response.success.ra_number;
                var frameSrc = cgiEndpoint +  "/cgi/cgpbsrrrf?pmcno="+raNumber;
                $('#rr-iframe').attr('src',frameSrc);
                $('.repairRequestContent').hide();
                $('.rr-iframeWrap').show();
                $('#SISTYLE, #rf-desc').val('');
                // $('#rf-color').find('option').first().attr('selected',true);
                $('html,body').animate({'scrollTop': 0},300);
                // window.location.href = "/pages/repair-confirmation";
              }
            },
            error: function (response) {
              if(response.error) {
                $('.loaderWrap').hide();
                $('.buttonInfoGrid').find('.repairErrorMsg').remove();
                $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.error.error_message+'</p>');
                setTimeout(function() {
                  $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
                },3000);
              } else {
                // ACDC BR-345 
                // Moves the success repsonse to the 'else' as well, 
                // Due to unresolved CORS error on the Shopify server side
                // Even though the API request is actually successful
                $('.loaderWrap').hide();
                $('#ra-number').closest("p").text("Your RA# will be emailed to you.");
                $('#description').text($("#rf-desc").val());
                $('#style_no').text($("#SISTYLE").text());
                // $('#color_name').text(response.success.style_info.Color);
                $('#cust_name').text($("#SINAME").val());
                $('#cust_addr1').text($("#SIADR1").val());
                $('#cust_addr2').text($("#SIADR2").val());
                $('#cust_city').text($("#SICITY").val());
                $('#cust_state').text($("#rf-state").val());
                $('#cust_zip').text($("#SIZIP").val());
                $('#cust_phone').text($("#SIPHON").val())
                $('#cust_mail').text($("#SIEMAIL").val());
                $("#ship-to_info .result").text("Please use the shipping address emailed to you.")
                $('.pr-response').addClass('showResponse');
                $('.prHeader').hide();
                $('.rsWrap').hide();
                $('#SISTYLE, #rf-desc').val('');
                $('html,body').animate({'scrollTop': 0},300);
            
                // END of ACDC BR-345 


                // $('.loaderWrap').hide();
                // $('.buttonInfoGrid').find('.repairErrorMsg').remove();
                // $('.buttonInfoGrid').append('<p class="repairErrorMsg">Failed to send a message.</p>');
                // setTimeout(function() {
                //   $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
                // },3000);
              }
              // console.log('ERROR!!! response is ', response)
              // $('.loaderWrap').hide();
              // $('.buttonInfoGrid').find('.repairErrorMsg').remove();
              // $('.buttonInfoGrid').append('<p class="repairErrorMsg">Failed to send a message.</p>');
              // setTimeout(function() {
              //   $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
              // },3000);
            }
          });
        }else{
          var ship_info = 'ship-to_info';
          $.ajax({
            data: form_data,
            url: cgiEndpoint + "/cgi/cgpbsrrh1",
            method: "POST",
            dataType: "json",
            success: function(response){
              if(response.error) {
                $('.loaderWrap').hide();
                console.log("response erorr!", response.error.error_message)
                $('.buttonInfoGrid').find('.repairErrorMsg').remove();
                $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.error.error_message+'</p>');
                setTimeout(function() {
                  $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
                },3000);
              } else {
                $('.loaderWrap').hide();
                $('#ra-number').text(response.success.ra_number);
                $('#description').text(response.success.repair_description);
                $('#style_no').text(response.success.style_info.Style);
                // $('#color_name').text(response.success.style_info.Color);
                $('#cust_name').text(response.success.customer_info.Name);
                $('#cust_addr1').text(response.success.customer_info['Address 1']);
                $('#cust_addr2').text(response.success.customer_info['Address 2']);
                $('#cust_city').text(response.success.customer_info.City);
                $('#cust_state').text(response.success.customer_info.State);
                $('#cust_zip').text(response.success.customer_info.Zip);
                $('#cust_phone').text(response.success.customer_info.Phone);
                $('#cust_mail').text(response.success.customer_info.Email);
                $('#ship_name').text(response.success['ship-to_info'].Name);
                $('#ship_addr1').text(response.success['ship-to_info']['Address 1']);
                $('#ship_addr2').text(response.success['ship-to_info']['Address 2']);
                $('#ship_city').text(response.success['ship-to_info'].City);
                $('#ship_state').text(response.success['ship-to_info'].State);
                $('#ship_zip').text(response.success['ship-to_info'].Zip);
                $('#ship_phone').text(response.success['ship-to_info'].Phone);
                $('#ship_mail').text(response.success['ship-to_info'].Email);
                $('.pr-response').addClass('showResponse');
                $('.prHeader').hide();
                $('.rsWrap').hide();
                $('#SISTYLE, #rf-desc').val('');
                // $('#rf-color').find('option').first().attr('selected',true);
                $('html,body').animate({'scrollTop': 0},300);
                // window.location.href = "/pages/repair-confirmation";
              }
            },
            error: function (response) {
              if(response.error) {
                $('.loaderWrap').hide();
                $('.buttonInfoGrid').find('.repairErrorMsg').remove();
                $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.error.error_message+'</p>');
                setTimeout(function() {
                  $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
                },3000);
              } else {
                // ACDC BR-345 
                // Moves the success repsonse to the 'else' as well, 
                // Due to unresolved CORS error on the Shopify server side
                // Even though the API request is actually successful
                $('.loaderWrap').hide();
                $('#ra-number').closest("p").text("Your RA# will be emailed to you.");
                $('#description').text($("#rf-desc").val());
                $('#style_no').text($("#SISTYLE").text());
                // $('#color_name').text(response.success.style_info.Color);
                $('#cust_name').text($("#SINAME").val());
                $('#cust_addr1').text($("#SIADR1").val());
                $('#cust_addr2').text($("#SIADR2").val());
                $('#cust_city').text($("#SICITY").val());
                $('#cust_state').text($("#rf-state").val());
                $('#cust_zip').text($("#SIZIP").val());
                $('#cust_phone').text($("#SIPHON").val())
                $('#cust_mail').text($("#SIEMAIL").val());
                $("#ship-to_info .result").text("Please use the shipping address emailed to you.")
                $('.pr-response').addClass('showResponse');
                $('.prHeader').hide();
                $('.rsWrap').hide();
                $('#SISTYLE, #rf-desc').val('');
                $('html,body').animate({'scrollTop': 0},300);
            
                // END of ACDC BR-345 


                // $('.loaderWrap').hide();
                // $('.buttonInfoGrid').find('.repairErrorMsg').remove();
                // $('.buttonInfoGrid').append('<p class="repairErrorMsg">Failed to send a message.</p>');
                // setTimeout(function() {
                //   $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
                // },3000);
              }
            }
          });
        }
    }
} else {
    // console.log("terms not checked!")
    $('.buttonInfoGrid').find('.repairErrorMsg').remove();
    $('.buttonInfoGrid').append('<p class="repairErrorMsg" id="repairErrorMsg">Please agree to terms to submit request</p>');
    $('#rf_terms').attr('aria-describedby', 'repairErrorMsg')
    $('#rf_terms').attr('aria-invalid', 'true')

    $('#rf_terms').focus()
    setTimeout(function() {
      $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
    },3000);
};
});

// Offers a FedEx print out shipping label upon submit and click on the response message

document.getElementById("pr-response").addEventListener("click", function() {
  var printContents = document.getElementById('pr-response').innerHTML;
  var originalContents = document.body.innerHTML;
  document.body.innerHTML = printContents;
  window.print();
  document.body.innerHTML = originalContents;

});
